import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const {
        contentLinks,
        loginUrl,
        registerUrl,
        isLoggedIn,
        logo,
        hideAuthButtons,
    } = useSelector((state) => state.navigation);

    return (
        <NavigationItem
            links={contentLinks}
            navigationInfo={{
                loginUrl,
                registerUrl,
                isLoggedIn,
                logo,
                hideAuthButtons,
            }}
        />
    );
};

export default Navigation;
